import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

import { ChakraCard } from '../Card/ChakraCard'
import NoResultsIcon from './NoResultsIcon'

interface NoResultsProps {
  children: string
}

export const NoResults = ({ children }: NoResultsProps) => {
  return (
    <ChakraCard alignItems="center" flexDirection="column">
      <Text color="neutral.70" fontSize="xl" fontWeight="bold" mb={6} mt={10}>
        {children}
      </Text>
      <Flex mb={10}>
        <NoResultsIcon />
      </Flex>
    </ChakraCard>
  )
}
